import { useEventBus } from '@vueuse/core'
import mitt from 'mitt'

export const errorBus = useEventBus('error')
export const personUpdateBus = useEventBus('person-update')
export const bulkActionsBus = useEventBus('bulk-actions')
export const orgChartBus = useEventBus('org-chart')
export const authBus = mitt()
export const scenarioRefreshStateBus = useEventBus('scenario-refresh-state')

export const BulkActions = {
  ManagerUpdated: 'manager-updated'
}

export const AuthActions = {
  MFAVerified: 'mfa-verified',
  Logout: 'logout'
}

export const OrgChartActions = {
  ToggleExpand: 'toggle-expand',
  ExpandNode: 'expand-node',
  ToggleDeleteConfirmation: 'toggle-delete-confirmation',
  ExpandAll: 'expand-all',
  ExpandExecutives: 'expand-executives',
  ExpandUpToLevel: 'expand-up-to-level',
  OpenProfile: 'open-profile',
  ZoomIn: 'zoom-in',
  ZoomOut: 'zoom-out',
  CollapseAll: 'collapse-all',
  FitScreen: 'fit-screen',
  LayoutToggle: 'layout-toggle',
  HighlightPerson: 'highlight-person',
  CenterRoot: 'center-root',
  NodeDragEnd: 'node-drag-end',
  HireDateChange: 'hire-date-change',
  UndoDeleteManager: 'undo-delete-manager',
  ReplacePerson: 'replace-person',
  MarkAsRif: 'mark-as-rif',
  DeletePerson: 'delete-person',
  PastePerson: 'paste-person',
  DuplicatePerson: 'duplicate-person',
  AddSubordinate: 'add-subordinate',
  AddDottedLine: 'add-dotted-line',
  MarkAsRoot: 'mark-as-root',
  UnmarkAsRoot: 'unmark-as-root',
  MoveNodeLeft: 'move-node-left',
  MoveNodeRight: 'move-node-right',
  RemoveTeam: 'remove-team',
  PredictSalary: 'predict-salary',
  DepartmentChange: 'department-change',
  LocationChange: 'location-change',
  RoleChange: 'role-change',
  NameChange: 'name-change',
  ExpandDefaultLevel: 'expand-default-level',
  SetLayout: 'set-layout',
  AssignPosition: 'assign-position',
  RaiseNode: 'raise-node',
  CustomFieldChange: 'custom-field-change',
  OpenComments: 'open-comments',
  OpenCommentThread: 'open-comment-thread',
  OpenFiltersMenu: 'open-filters-menu',
  OpenNewRole: 'open-new-role',
  DayforceSyncState: 'dayforce-sync-state'
}
